import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'

import withConnectionStatus from '../hocs/withConnectionStatus'

class ConnectionStatusPopup extends React.Component {
  state = {
    open: false
  }

  componentDidUpdate(prevProps) {
    if (prevProps.connectionStatus !== this.props.connectionStatus) {
      this.setState({ open: true })
    }
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { open } = this.state
    const { connectionStatus } = this.props

    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id'
        }}
        message={<span id="message-id">{connectionStatus}</span>}
        autoHideDuration={6000}
      />
    )
  }
}

export default withConnectionStatus(ConnectionStatusPopup)



// WEBPACK FOOTER //
// ./src/components/ConnectionStatusPopup.js